import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useId } from "react";
import { useIntl } from "react-intl";
import { SettingOptionItem } from "services/KnowfullyAdminClient";

type SettingsOptionsSelectProps = {
  settingOptions: SettingOptionItem[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
};

export default function SettingsOptionsSelect({
  settingOptions,
  value,
  onChange,
  error,
}: SettingsOptionsSelectProps) {
  const { formatMessage: t } = useIntl();
  const labelId = useId();
  const errorId = useId();

  return (
    <FormControl variant="standard" fullWidth error={!!error}>
      <InputLabel id={labelId} required>
        {t({ id: "valueLabel" })}
      </InputLabel>
      <Select
        labelId={labelId}
        aria-describedby={error ? errorId : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {settingOptions.map((option) => (
          <MenuItem key={option.id} value={option.value}>
            {option.value}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText id={errorId}>{error}</FormHelperText>}
    </FormControl>
  );
}
